import { BccRecipientLabel } from 'owa-locstrings/lib/strings/bccrecipientlabel.locstring.json';
import { ToRecipientLabel, CcRecipientLabel } from './getRecipientString.locstring.json';
import loc from 'owa-localize';
import { RecipientType } from 'owa-recipient-types/lib/types/RecipientType';

export default function getRecipientString(recipientType: RecipientType) {
    switch (recipientType) {
        case RecipientType.To:
            return loc(ToRecipientLabel);
        case RecipientType.Cc:
            return loc(CcRecipientLabel);
        case RecipientType.Bcc:
            return loc(BccRecipientLabel);
        default:
            throw new Error(
                `There is no localized string for RecipientType.${RecipientType[recipientType]}`
            );
    }
}
